import { api } from "@/api";

export interface Role {
  role_id: number;
  role_code: string;
  role_name: string;
}

/* ==========================
   Roles
========================== */
export const getRoles = async (): Promise<Role[]> => {
  const res = await api.getRoles();
  return res.roles || [];
};

/* ==========================
   All Programs Visibility
========================== */
export const saveAllProgramsVisibility = async (
  visibility: Record<string, boolean>,
  updatedBy: string
) => {
  return api.saveAllProgramsVisibility({
    updatedBy,
    visibility,
  });
};
